import { useRouteMatch } from 'react-router';

import { Route as Routes } from 'src/shared/route';

const useIsSharedView = (): boolean => {
  const sharedViewMatch = useRouteMatch(Routes.RENDERINGS_SHARED.path);
  return !!sharedViewMatch;
};

export { useIsSharedView };
